import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import * as CryptoJS from 'crypto-js';
import { SharedConstants } from './shared/shared-constants';

@Injectable()
export class UploadFileService {
  constructor() {}

  private decrypt(encryptedText: string, passPhrase: string): string {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedText, passPhrase);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return '';
    }
  }

  uploadfile(file, key: string): Promise<string> {

    const imsmartPathPart1 = this.decrypt(SharedConstants.stringPaths.pathPart1, SharedConstants.stringPaths.testString);
    const imsmartPathPart2 = this.decrypt(SharedConstants.stringPaths.pathPart2, SharedConstants.stringPaths.testString);
    const imsmartPath = imsmartPathPart1 + imsmartPathPart2;

    const imsmartAddyPart1 = this.decrypt(SharedConstants.stringPaths.addyPart1, SharedConstants.stringPaths.testString);
    const imsmartAddyPart2 = this.decrypt(SharedConstants.stringPaths.addyPart2, SharedConstants.stringPaths.testString);
    const imsmartAddy = imsmartAddyPart1 + imsmartAddyPart2;

    return new Promise((resolve, reject) => {
      const bucket = new S3({
        accessKeyId: imsmartPath,
        secretAccessKey: imsmartAddy,
        region: 'us-east-1',
      });

      const params = {
        Bucket: 'imsmart-pdfs',
        Key: key,
        Body: file,
        ContentType: file.type,
        ContentLength: file.size,
        ACL: 'public-read',
      };

      bucket.upload(params, (err, data) => {
        if (err) reject(err);
        resolve(data.Location);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/upload-file.service.ts